<wdpr-modal #createCharacterModal hide-close-icon disable-close-on-background>
  <h5 slot="title">{{isUpdate ? 'Update Character Profile' : 'Create Character'}}</h5>
  <div slot="body">
    <form class="characterForm" [formGroup]="characterForm" (ngSubmit)="next()">
      @if (!isUpdate) {
        <div>
          <label class="mb-0" for="characterName">Character Name</label><span class="error">*</span>
          <input id="characterName" placeholder="Enter Character Name" formControlName="characterName" class="form-control w-75"
            type="text" [(ngModel)]="characterName">
          @if (isExist) {
            <span class="error">Character already exists</span>
          }
        </div>
      }
      @if (isUpdate) {
        <div class="mt-2">
          <label class="mb-0" for="characterStatus">Status</label>
          <select id="characterStatus" class="site-select w-75" formControlName="status">
            @for (option of allStatus; track option) {
              <option [ngValue]="option.value">
                {{ option.value }}
              </option>
            }
          </select>
        </div>
      }
      <div class="row">
        <div class="col-md-5">
          <div class="mt-2">
            <label class="mb-0" for="imageId">Image ID</label>
            <input id="imageId" placeholder="Enter Image ID" class="form-control w-100" type="text" [(ngModel)]="imageId"
              formControlName="imageId">
          </div>
        </div>
        <div class="col-md-3 p-0">
          <div class="mt-2 image-preview">
            <span class="mb-0 ps-1">Image Preview</span>
            <div>
              @if (imageUrl) {
                <img class="char-img" [src]="imageUrl" alt="Character preview">
              }
              @if (!imageUrl) {
                <img alt="">
                }
              </div>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <wdpr-button [disabled]="!imageId" class="check-image" theme="inline-primary"
            (click)="checkImage()">Check Image</wdpr-button>
          </div>
        </div>
      </form>
    </div>

    <wdpr-button class="mx-0" slot="buttons" theme="primary" (click)="next()" [disabled]="(!characterForm.get('characterName').value)
        && !isUpdate">
    {{ isUpdate ? 'Save' : 'Continue' }}</wdpr-button>
    <wdpr-button slot="buttons" theme="secondary" (click)="close(true)">Cancel</wdpr-button>
  </wdpr-modal>
  <app-toast></app-toast>